<template>
  <div class="mt-5 text-center">
    <button
      id="continue-btn"
      class="btn btn-dark lightbox-btn btn-lg mt-3"
      data-test="btn-continue"
      type="submit"
      @click="$emit('submit')"
    >
      {{ $t ('label.continue') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'Continue'
}
</script>
